import React from "react";
import LeftMeetingHeaderSection from "./LeftMeetingHeaderSection";
import LeftMeetingHomeSection from "./LeftMeetingHomeSection";

const LeftMeetingComponent = () => {
  return (
    <div>
      <LeftMeetingHeaderSection />
      <LeftMeetingHomeSection />
    </div>
  );
};

export default LeftMeetingComponent;
